import { SelectComplexDataField } from "@components/select-complex-data-field";
import { useTranslation } from "@i18n/hooks";
import {
	SelectMultipleAccountsFieldProps,
	SelectMultipleAccountsFieldState,
} from "./select-multiple-accounts-field.types";
import { SearchableAccountTable } from "../searchable-account-table";

export const SelectMultipleAccountsField = ({ ...props }: SelectMultipleAccountsFieldProps) => {
	const { t } = useTranslation("common");
	return (
		<SelectComplexDataField<SelectMultipleAccountsFieldState>
			valuePlaceholder={t("account.noAccountsSelected")}
			actionButtonLabel={t("account.selectAccounts")}
			headerLabel={t("account.selectAtLeastOne")}
			{...props}
		>
			<SearchableAccountTable
				selection={props.fieldValue}
				onChange={props.updateField}
				selectionMode="multiple"
			/>
		</SelectComplexDataField>
	);
};
